import { render, staticRenderFns } from "./EModalEfetivarPreMatricula.vue?vue&type=template&id=51249786"
import script from "./EModalEfetivarPreMatricula.vue?vue&type=script&lang=js"
export * from "./EModalEfetivarPreMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports